import { useAuthStore } from "@/stores/auth";

/**
 * Resource APIs are authorized by X-Shop-Id, so cross-Shop links must select
 * the resource's Shop before the destination route starts fetching.
 */
export function selectResourceShopForNavigation(shopId: string): void {
  const { currentShopId, setCurrentShop } = useAuthStore.getState();
  if (currentShopId !== shopId) setCurrentShop(shopId);
}
